import type { ReactNode } from "react";

export interface ProgressProps {
  value: number;
  label?: ReactNode;
  sub?: ReactNode;
}

export function Progress({ value, label, sub }: ProgressProps) {
  return (
    <div>
      <div className="flex items-baseline justify-between mb-2">
        {label && <div className="label">{label}</div>}
        <div className="mono text-[12px] text-[var(--ink)] tabular">{Math.round(value)}%</div>
      </div>
      <div className="h-[2px] bg-[var(--rule-2)] relative overflow-hidden">
        <div
          className="absolute inset-y-0 left-0 bg-[var(--ink)] transition-all duration-200"
          style={{ width: `${value}%` }}
        />
      </div>
      {sub && <div className="caption mt-2">{sub}</div>}
    </div>
  );
}
